// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2v2qP","title":"AfterBackImages_title__x22nW","images":"AfterBackImages_images__2deE8"};